/**
 * Online Order Form DB Service REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OofOrderItemConfigurationDto } from './oofOrderItemConfigurationDto';
import { DeviceAllocationsDto } from './deviceAllocationsDto';
import { ArticleDto } from './articleDto';


export interface OofOrderItemDto { 
    id?: number;
    index?: number;
    comment?: string;
    name?: string;
    amount?: number;
    articles?: Array<ArticleDto>;
    orderItemConfigurations?: Array<OofOrderItemConfigurationDto>;
    reminderTimestamp?: string;
    deviceAllocations?: DeviceAllocationsDto;
    status?: OofOrderItemDto.StatusEnum;
}
export namespace OofOrderItemDto {
    export const StatusEnum = {
        Incomplete: 'INCOMPLETE',
        Fulfilled: 'FULFILLED',
        Submitted: 'SUBMITTED',
        InProduction: 'IN_PRODUCTION',
        Packed: 'PACKED',
        Shipped: 'SHIPPED',
        Canceled: 'CANCELED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


